export function FirstPitchIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="20" r="8" />
      <path d="M20 16c2 2 6 2 8 0" />
      <path d="M20 24c2-2 6-2 8 0" />
      <path d="M18 36l6-10 6 10" />
      <line x1="24" y1="26" x2="24" y2="30" />
    </svg>
  );
}
